var _polygon, _path, _polygon2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.9,96.33a15.76,15.76,0,0,1-.39-3.43,28,28,0,0,0-.46-4.12A40.12,40.12,0,0,0,141,83.25,51.8,51.8,0,0,0,135.23,69,53.39,53.39,0,0,0,122,53.77a52.78,52.78,0,0,0-49.72-8.55,49.82,49.82,0,0,0-13.44,6.86A58.92,58.92,0,0,0,52.76,57a60.21,60.21,0,0,0-5.28,6A52.32,52.32,0,0,0,46,125a59.24,59.24,0,0,0,5,6.22,58.34,58.34,0,0,0,5.83,5.22A49.43,49.43,0,0,0,69.88,144a53.16,53.16,0,0,0,64-20.71,52.11,52.11,0,0,0,6.43-13.94,40.42,40.42,0,0,0,1.35-5.47,30.11,30.11,0,0,0,.66-4.09,15.52,15.52,0,0,1,.55-3.41,14.74,14.74,0,0,1,0,3.46,24,24,0,0,1-.38,4.18,36.66,36.66,0,0,1-1.11,5.64,50.76,50.76,0,0,1-6.14,14.51,54.66,54.66,0,0,1-37.47,25.32,55.16,55.16,0,0,1-29-2.95A51.91,51.91,0,0,1,55,138.68a62.33,62.33,0,0,1-6.17-5.48,63.36,63.36,0,0,1-5.29-6.53,55,55,0,0,1,1.6-65.47,63.14,63.14,0,0,1,5.59-6.27,61.3,61.3,0,0,1,6.43-5.16,51.62,51.62,0,0,1,14.2-7.14,55.19,55.19,0,0,1,29.07-1.54,54.67,54.67,0,0,1,36.2,27.11A50.9,50.9,0,0,1,142.1,83a37.44,37.44,0,0,1,.83,5.68,23.6,23.6,0,0,1,.18,4.2A15.34,15.34,0,0,1,142.9,96.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,62.63c.12.17-.85,1-2.73,2.41l-3.47,2.49c-.69.47-1.41,1-2.21,1.51L121,70.43a60.8,60.8,0,0,1-31.71,8l-4.8-.21-4.6-.72c-.75-.13-1.51-.23-2.24-.38l-2.15-.57c-1.41-.39-2.81-.73-4.15-1.15a69.64,69.64,0,0,1-13.45-6.2c-7.23-4.37-10.75-8.35-10.47-8.6s4.22,3,11.5,6.77a81,81,0,0,0,13.24,5.42c1.29.37,2.64.66,4,1l2.07.51,2.14.32,4.4.65,4.58.19a65.75,65.75,0,0,0,30.7-6.9l2.69-1.17c.82-.42,1.56-.88,2.28-1.28l3.68-2C130.8,63,132,62.47,132.11,62.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.82,128.21c-.12-.17.86-1,2.74-2.41L52,123.31c.68-.47,1.4-1,2.21-1.51l2.65-1.38a60.92,60.92,0,0,1,31.71-8l4.8.21,4.61.72c.75.13,1.5.23,2.24.38l2.15.57c1.41.4,2.81.73,4.14,1.16A69.49,69.49,0,0,1,120,121.66c7.23,4.37,10.74,8.35,10.47,8.61s-4.22-3-11.5-6.78a81.34,81.34,0,0,0-13.24-5.42c-1.29-.37-2.64-.66-4-1l-2.06-.51-2.15-.32-4.4-.65-4.57-.18a65.68,65.68,0,0,0-30.71,6.89l-2.69,1.17c-.81.42-1.56.88-2.27,1.28l-3.68,2C47.14,127.85,45.94,128.38,45.82,128.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87,97.58c0,.82-24.18.9-54,.18S35,95.78,35,95s24.18-.89,54-.17S142.89,96.76,142.87,97.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46,148.89c-.82,0-.9-24.17-.17-53.94s2-53.89,2.79-53.87.9,24.17.17,54S87.28,148.91,86.46,148.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46,148.81c-.2.32-6.14-3.71-13-12.83a72.63,72.63,0,0,1-9.64-17.51,65,65,0,0,1-4.17-24.16,61.68,61.68,0,0,1,5.44-23.92,74.62,74.62,0,0,1,10.54-17c7.26-8.77,13.25-12.67,13.45-12.35s-5.14,4.75-11.8,13.64A80.7,80.7,0,0,0,67.6,71.47a62.2,62.2,0,0,0-5,22.89,65.64,65.64,0,0,0,3.78,23.18,77.52,77.52,0,0,0,8.78,17.22C81.41,144,86.76,148.49,86.46,148.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,41.1c.2-.32,6.14,3.71,13,12.83a72.63,72.63,0,0,1,9.64,17.51A65,65,0,0,1,117.1,95.6a61.68,61.68,0,0,1-5.44,23.92,75,75,0,0,1-10.53,17c-7.27,8.77-13.26,12.67-13.46,12.35s5.14-4.75,11.8-13.64a80.7,80.7,0,0,0,9.68-16.76,62.25,62.25,0,0,0,5-22.89,65.64,65.64,0,0,0-3.78-23.18,77.52,77.52,0,0,0-8.78-17.22C95.34,46,90,41.42,90.29,41.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.88,188.85H650.12a4.56,4.56,0,0,1-4.56-4.55v-53a5.38,5.38,0,0,1,5.38-5.38h47.12a5.37,5.37,0,0,1,5.37,5.38v53A4.55,4.55,0,0,1,698.88,188.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.88,188.85s.21,0,.6-.07a4.25,4.25,0,0,0,1.64-.58,4.56,4.56,0,0,0,1.85-2.08c.51-1,.35-2.36.36-3.83,0-5.92,0-14.45-.08-25,0-5.27,0-11.05,0-17.24,0-1.55,0-3.13,0-4.73v-2.42a21.39,21.39,0,0,0-.07-2.42,5.17,5.17,0,0,0-2.71-3.77,5.3,5.3,0,0,0-2.35-.58h-2.6l-21.87,0H653.13a29.08,29.08,0,0,0-3,.06,5.16,5.16,0,0,0-4.11,3.53,9.58,9.58,0,0,0-.23,2.86v14.53c0,7.58,0,14.9,0,21.88,0,3.48,0,6.88,0,10.18,0,1.66,0,3.28,0,4.88a4.39,4.39,0,0,0,2,3.84,4.24,4.24,0,0,0,2.06.68c.73,0,1.51,0,2.25,0h4.4l8.28,0,25,.08,6.79.05,1.77,0c.4,0,.6,0,.6,0s-.2,0-.6,0l-1.77,0-6.79,0-25,.09H652.07c-.76,0-1.49,0-2.28,0a4.77,4.77,0,0,1-4.45-5c0-1.6,0-3.22,0-4.88,0-3.3,0-6.7,0-10.18,0-7,0-14.3,0-21.88,0-3.8,0-7.66,0-11.58v-3c0-.49,0-1,0-1.49a5.69,5.69,0,0,1,.25-1.53,5.63,5.63,0,0,1,4.53-3.88,10.13,10.13,0,0,1,1.54-.08h22l21.87,0h2.6a5.68,5.68,0,0,1,2.57.64,5.6,5.6,0,0,1,2.94,4.11,20.94,20.94,0,0,1,.07,2.49v2.42c0,1.6,0,3.18,0,4.73,0,6.19,0,12,0,17.24,0,10.53-.06,19.06-.08,25,0,.74,0,1.43,0,2.09a4.59,4.59,0,0,1-2.35,3.91,4.06,4.06,0,0,1-1.69.54A3.4,3.4,0,0,1,698.88,188.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649,125.91h51a3.44,3.44,0,0,1,3.44,3.44v10.35a0,0,0,0,1,0,0H645.56a0,0,0,0,1,0,0V129.36A3.44,3.44,0,0,1,649,125.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.61,133.54a1.84,1.84,0,1,1-1.84-1.82A1.82,1.82,0,0,1,655.61,133.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.66,133.54a1.84,1.84,0,1,1-1.84-1.82A1.83,1.83,0,0,1,660.66,133.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.8,133.54a1.84,1.84,0,1,1-1.84-1.82A1.82,1.82,0,0,1,665.8,133.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.82,
    y: 147.24,
    width: 31.15,
    height: 30.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.82,44.84h83.25a5.38,5.38,0,0,1,5.38,5.38v59.65a4.55,4.55,0,0,1-4.55,4.55H601a4.55,4.55,0,0,1-4.55-4.55V50.22A5.38,5.38,0,0,1,601.82,44.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.82,44.84h83.25a5.38,5.38,0,0,1,5.38,5.38v9.87a0,0,0,0,1,0,0h-94a0,0,0,0,1,0,0V50.22A5.38,5.38,0,0,1,601.82,44.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,53.27a2.79,2.79,0,1,1-2.78-2.79A2.79,2.79,0,0,1,609,53.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.49,53.27a2.78,2.78,0,1,1-2.78-2.79A2.79,2.79,0,0,1,617.49,53.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626,53.27a2.78,2.78,0,1,1-2.78-2.79A2.78,2.78,0,0,1,626,53.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.31,114.42s.29,0,.82-.11a4.12,4.12,0,0,0,2.07-1.14,4.37,4.37,0,0,0,1.18-3.58c0-1.55,0-3.35,0-5.37,0-8.09,0-19.78-.07-34.22,0-3.62,0-7.4,0-11.35v-6c0-1,0-2.07,0-3.09a4.65,4.65,0,0,0-3.64-4.37A6.25,6.25,0,0,0,685,45H602.65a15,15,0,0,0-2,.06,4.63,4.63,0,0,0-3.2,2.06,4.74,4.74,0,0,0-.68,1.81,14.75,14.75,0,0,0-.06,2v8.11q0,8.06,0,15.86c0,10.4,0,20.43,0,30v5.33a3.92,3.92,0,0,0,.35,1.61A4,4,0,0,0,599.4,114a4.87,4.87,0,0,0,1.63.18H615.9l23.64,0,34.22.08,9.31,0,2.42,0c.55,0,.82,0,.82,0l-.82,0-2.42,0-9.31,0-34.22.08-23.64,0-13.17,0H601a5.36,5.36,0,0,1-1.76-.2,4.35,4.35,0,0,1-3-4.13v-1.77c0-1.18,0-2.36,0-3.56,0-9.55,0-19.58,0-30V51a16.26,16.26,0,0,1,.06-2.08,5.19,5.19,0,0,1,.76-2,5.11,5.11,0,0,1,3.52-2.27,18.73,18.73,0,0,1,2.1-.07H685a6.72,6.72,0,0,1,1.66.13,5.06,5.06,0,0,1,3.94,4.74c0,1.06,0,2.08,0,3.11v6c0,4,0,7.73,0,11.35,0,14.44-.05,26.13-.07,34.22,0,2,0,3.82,0,5.37a4.51,4.51,0,0,1-1.25,3.65,4.11,4.11,0,0,1-2.13,1.12A3.46,3.46,0,0,1,686.31,114.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.86,
    y: 70.1,
    width: 33.95,
    height: 33.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.37,
    y: 72.16,
    width: 34.97,
    height: 2.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.37,
    y: 78.81,
    width: 34.97,
    height: 2.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.37,
    y: 85.46,
    width: 34.97,
    height: 2.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.37,
    y: 92.1,
    width: 34.97,
    height: 2.91,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698,465.88c0,.15-148.66.26-332,.26S34,466,34,465.88s148.63-.26,332-.26S698,465.74,698,465.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.05,70H113.17a14,14,0,0,0-14,14V400.33a14,14,0,0,0,14,14h171.9s10.93,33.81-23,51.3H422.84s-38.27-13.12-28.43-51.3H561.05a14,14,0,0,0,14-14V84A14,14,0,0,0,561.05,70Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,381c6.09,8.71-3.44,18.25-12.15,12.16a3.34,3.34,0,0,1-.75-.75c-6.08-8.71,3.45-18.23,12.15-12.15A3.1,3.1,0,0,1,343.09,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6,75.8h441a9.7,9.7,0,0,1,9.7,9.7V356.44a0,0,0,0,1,0,0H106.9a0,0,0,0,1,0,0V85.5a9.7,9.7,0,0,1,9.7-9.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.05,75.8H559.81a7.52,7.52,0,0,1,7.52,7.52v15.8a0,0,0,0,1,0,0H106.9a0,0,0,0,1,0,0V85A9.15,9.15,0,0,1,116.05,75.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,88a3.24,3.24,0,1,1-3.24-3.24A3.24,3.24,0,0,1,124.8,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,88a3.24,3.24,0,1,1-3.24-3.24A3.24,3.24,0,0,1,134.44,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.61,88a3.24,3.24,0,1,1-3.24-3.24A3.24,3.24,0,0,1,143.61,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,414.36c0,.15-63.74.27-142.34.27s-142.35-.12-142.35-.27,63.72-.27,142.35-.27S481,414.21,481,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.4,
    y: 284.91,
    width: 101.93,
    height: 14.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.4,
    y: 309.54,
    width: 379.77,
    height: 14.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.81,
    y: 133.85,
    width: 460.6,
    height: 134.97,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.72,
    y: 112.74,
    width: 45.02,
    height: 11.86,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.05,
    y: 110.06,
    width: 19.45,
    height: 11.86,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.98,
    y: 110.06,
    width: 32.59,
    height: 11.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.44,
    y: 109.74,
    width: 32.59,
    height: 11.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.9,
    y: 109.43,
    width: 32.59,
    height: 11.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,254.77a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,310.63,254.77Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,254.77a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,326.93,254.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,254.77a4.1,4.1,0,1,1-4.09-4.09A4.09,4.09,0,0,1,342.5,254.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,181.56v23.68H191.74V183.93c0-6-2.59-8.48-6.79-8.48-4.66,0-8.25,2.9-8.25,9.78v20H162.19v-41.4H176v4.51a17.77,17.77,0,0,1,13.14-5.19C198.85,163.16,206.25,168.73,206.25,181.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,188.21H227.94c1.22,4.2,4.81,6.64,10.16,6.64a13.27,13.27,0,0,0,9.54-3.59l7.64,7.94c-4,4.43-9.78,6.72-17.64,6.72-14.74,0-24.29-9.08-24.29-21.46s9.7-21.3,22.76-21.3c12.22,0,22.15,7.79,22.15,21.46C258.26,185.69,258.11,187.06,258,188.21Zm-30.32-7.64h16.95a8.61,8.61,0,0,0-16.95,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.79,163.84l-14.74,41.4H304l-7.79-22.53-8.09,22.53H274.06l-14.74-41.4h13.75l8.48,25,8.78-25H302.7l8.56,25.28L320,163.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.89,
    y: 219.99,
    width: 156.95,
    height: 13.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "504.69 133.89 530.99 234.04 390 267.81 363.43 156.84 462.04 133.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,133.22s-.6.17-1.78.46L455.05,135l-19.89,4.83-71.68,17.26.15-.26c7.62,31.75,16.76,69.82,26.63,111l-.32-.19,16-3.84,125-29.89-.16.27c-7.89-30.21-14.43-55.25-19-72.76-2.27-8.74-4-15.6-5.26-20.28-.6-2.33-1.06-4.12-1.37-5.34s-.45-1.83-.45-1.83.19.61.52,1.82.8,3,1.43,5.32L512,161.28c4.61,17.49,11.22,42.52,19.18,72.71l.06.21-.22.05-124.94,30-16,3.85-.25.06-.06-.26c-9.84-41.15-18.94-79.22-26.53-111l-.05-.21.21-.05,71.72-17.08L455,134.84l5.23-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.12 259.68 522.17 228.77 497.45 134.04 369.88 162.68 393.12 259.68",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,259.68s-.16-.58-.44-1.73-.71-2.89-1.25-5.12c-1.1-4.52-2.7-11.13-4.75-19.56-4.08-16.94-9.93-41.2-17-70.54l-.06-.21.22-.05,127.55-28.68.25,0,.06.24V134c8.86,34,17.26,66.2,24.69,94.68l.06.23-.24.06-93.28,22.22-26.44,6.27-7,1.65-1.79.41-.6.13.62-.16,1.81-.45,7-1.71L429,251l93.08-22.42-.17.29c-7.44-28.47-15.85-60.68-24.73-94.67v0l.3.19L369.93,162.89l.16-.26c7,29.31,12.74,53.54,16.76,70.46,2,8.47,3.58,15.1,4.65,19.63.53,2.26.94,4,1.21,5.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "393.12 259.68 423.75 188.59 460.71 219.63 474.81 194.92 522.17 228.77 393.12 259.68"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.75,171.68A10.45,10.45,0,1,1,449.16,164,10.43,10.43,0,0,1,461.75,171.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M383.93,281.24l-7.68-15.06a.55.55,0,0,1,.23-.74l5.93-3.28a.56.56,0,0,0,.09-.92l-21.42-18a1.38,1.38,0,0,0-2.26,1.18l2.59,27.9a.56.56,0,0,0,.81.45l6.34-3.19a.56.56,0,0,1,.75.24l8,15a.73.73,0,0,0,1,.3l5.37-2.93A.74.74,0,0,0,383.93,281.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,243.29a9.78,9.78,0,0,1-2.19-.9c-1.31-.62-3.12-1.5-5.09-2.51-4-2-7.1-3.79-7-3.95a15.58,15.58,0,0,1,2.16.95c1.31.63,3.11,1.52,5.08,2.53s3.76,2,5,2.65A11,11,0,0,1,357.13,243.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,241.37a74.7,74.7,0,0,1-2.39-8.48,76,76,0,0,1-1.88-8.6,74.7,74.7,0,0,1,2.39,8.48A73.42,73.42,0,0,1,360.68,241.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.6,241.17a67.05,67.05,0,0,1,6.83-9.68,33.14,33.14,0,0,1-3.2,5A34.41,34.41,0,0,1,364.6,241.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.18,247.16a24.53,24.53,0,0,1-4.62,1.78,23.82,23.82,0,0,1-4.77,1.3,46.36,46.36,0,0,1,9.39-3.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.75,215.37H710.56a5.38,5.38,0,0,1,5.38,5.38V430.52a4.55,4.55,0,0,1-4.55,4.55H478.93a4.55,4.55,0,0,1-4.55-4.55V220.75A5.38,5.38,0,0,1,479.75,215.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.75,215.41H710.56a5.38,5.38,0,0,1,5.38,5.38V242.7a0,0,0,0,1,0,0H474.37a0,0,0,0,1,0,0V220.79A5.38,5.38,0,0,1,479.75,215.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.26,231.13a5.27,5.27,0,1,1-5.27-5.27A5.27,5.27,0,0,1,496.26,231.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.43,231.13a5.27,5.27,0,1,1-5.27-5.27A5.27,5.27,0,0,1,512.43,231.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.6,231.13a5.27,5.27,0,1,1-5.27-5.27A5.27,5.27,0,0,1,528.6,231.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.27,295v14.12h-8.66V296.44c0-3.55-1.55-5.06-4.05-5.06-2.78,0-4.92,1.73-4.92,5.83v11.94H489V284.46h8.25v2.68a10.64,10.64,0,0,1,7.83-3.09C510.85,284.05,515.27,287.37,515.27,295Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,299H528.21c.73,2.51,2.87,4,6.06,4a7.92,7.92,0,0,0,5.7-2.15l4.55,4.74c-2.37,2.64-5.83,4-10.52,4-8.79,0-14.49-5.42-14.49-12.8s5.79-12.71,13.58-12.71c7.29,0,13.21,4.64,13.21,12.8C546.3,297.49,546.21,298.31,546.16,299Zm-18.08-4.56h10.11a5.14,5.14,0,0,0-10.11,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.77,284.46,582,309.15h-8.39L569,295.71l-4.83,13.44h-8.39l-8.79-24.69h8.2l5.06,14.94,5.24-14.94h7.38l5.1,15.08,5.24-15.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.39,
    y: 318.46,
    width: 100.43,
    height: 8.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.39,
    y: 331.95,
    width: 36.21,
    height: 8.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.16 258.85 668.54 264.78 605.44 279.89 622.45 350.89 712.66 329.29 694.16 258.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.16,258.85s.13.42.36,1.26l1,3.72c.88,3.28,2.16,8.09,3.79,14.21,3.26,12.32,7.93,29.94,13.56,51.19l0,.21-.21.06L623.19,351l-.68.17-.25.06-.06-.26c-6.14-25.66-11.93-49.88-17-71l-.06-.22.23-.06,64.14-15.25,18.21-4.14,4.79-1.07,1.23-.27.4-.08-.42.11-1.24.3-4.81,1.15-18.1,4.27L605.5,280.12l.17-.28c5.06,21.11,10.88,45.34,17,71l-.31-.19.68-.16,89.54-21.4-.16.26c-5.52-21.22-10.1-38.81-13.31-51.12-1.59-6.15-2.84-11-3.69-14.29-.42-1.64-.74-2.9-1-3.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.44 345.69 707.01 325.91 691.2 265.3 609.58 283.63 624.44 345.69",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.44,345.69s-.1-.36-.29-1.1-.45-1.85-.8-3.27c-.71-2.89-1.74-7.11-3.06-12.5-2.62-10.85-6.38-26.37-10.92-45.14l0-.21.21-.05,81.61-18.37.24-.06.07.25v0c5.66,21.75,11,42.36,15.78,60.58l.06.24-.23.05-59.73,14.19-16.91,4-4.47,1-1.14.26-.38.08.4-.11,1.16-.29,4.5-1.11,16.94-4.12L707,325.68l-.17.29C702,307.75,696.64,287.15,691,265.4v0l.31.19-81.63,18.28.16-.26c4.44,18.73,8.12,34.23,10.68,45.06,1.28,5.42,2.27,9.67,3,12.58.33,1.44.59,2.55.77,3.31S624.44,345.69,624.44,345.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "624.44 345.69 644.04 300.2 667.69 320.06 676.71 304.26 707.01 325.91 624.44 345.69"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M668.36,289.38a6.69,6.69,0,1,1-8.06-4.94A6.69,6.69,0,0,1,668.36,289.38Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 488.96,
    y: 363.71,
    width: 204.5,
    height: 3.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.96,
    y: 375.18,
    width: 204.5,
    height: 3.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.96,
    y: 386.73,
    width: 101.76,
    height: 3.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.16,
    cy: 414.99,
    r: 10.92,
    transform: "translate(-119.13 542.39) rotate(-45)",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.16,425.93A10.94,10.94,0,1,1,606.1,415,11,11,0,0,1,595.16,425.93Zm0-21.83A10.89,10.89,0,1,0,606.05,415,10.9,10.9,0,0,0,595.16,404.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.29,419.26a1.84,1.84,0,0,1-1.38-.64l-4.36-5a1,1,0,0,1,1.51-1.31l4.22,4.86,3.92-5.45a1,1,0,0,1,1.39-.23,1,1,0,0,1,.23,1.4l-4,5.62a1.87,1.87,0,0,1-1.41.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.39,435.08s.2,0,.59-.06a4.23,4.23,0,0,0,1.65-.57,4.51,4.51,0,0,0,1.89-2.11c.52-1,.34-2.44.37-3.95,0-6.09,0-15.07,0-26.63,0-23.13-.05-56.59-.08-97.94,0-20.68,0-43.32,0-67.64V222.34a19.51,19.51,0,0,0-.06-2.31,5.11,5.11,0,0,0-.78-2.09,5.2,5.2,0,0,0-3.73-2.31c-1.53-.07-3.16,0-4.74,0H656.82L479,215.7a5.1,5.1,0,0,0-4.09,3.43,8.5,8.5,0,0,0-.27,2.83v83.26c0,29.76,0,58.46,0,85.8q0,20.49,0,39.93a4.38,4.38,0,0,0,2.58,3.54,5,5,0,0,0,2.27.36H509.9l67.64,0,97.94.09,26.62,0,6.93,0,2.36,0s-.8,0-2.36,0l-6.93,0-26.62.05-97.94.08-67.64,0H479.47a5.49,5.49,0,0,1-2.45-.39,4.82,4.82,0,0,1-2.85-3.92q0-19.44,0-40c0-27.34,0-56,0-85.8V259.84q0-11.52,0-23.21V222a8.86,8.86,0,0,1,.3-3,5.63,5.63,0,0,1,4.51-3.78l177.9-.05h49.59c1.6,0,3.16,0,4.79,0a5.58,5.58,0,0,1,4.9,4.78,21,21,0,0,1,.06,2.37v13.84c0,24.32,0,47,0,67.64,0,41.35-.06,74.81-.08,97.94,0,11.56,0,20.54,0,26.63,0,1.5.14,2.9-.4,4a4.49,4.49,0,0,1-1.94,2.13,4.2,4.2,0,0,1-1.67.55A4.35,4.35,0,0,1,711.39,435.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "650.12 196.56 594.82 196.56 622.47 236.14 650.12 196.56",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.13,142s49.19-2.1,49.19,35.66v20.08H613.44l-.29-19.79S614.5,154,581.13,142Z",
    style: {
      fill: "#17C1E8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.15,391.65c.13.07-6.31,11.46-14.39,25.42S120,442.3,119.88,442.22s6.31-11.46,14.39-25.43S149,391.57,149.15,391.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,437.64s-.16-.14-.41-.44l-1.08-1.33-4-4.91c-3.35-4.15-8.06-9.8-13.47-15.87s-10.5-11.4-14.23-15.2l-4.44-4.49-1.2-1.23a2.4,2.4,0,0,1-.39-.46,2.37,2.37,0,0,1,.47.38l1.27,1.15c1.1,1,2.66,2.5,4.56,4.37,3.81,3.74,9,9,14.37,15.11s10.09,11.78,13.37,16c1.64,2.1,2.94,3.82,3.82,5l1,1.4A2.55,2.55,0,0,1,162,437.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,447.49c-.16.12-1.86-3.15-4.49-8.43s-6.19-12.63-10.07-20.77-7.36-15.52-9.85-20.87l-2.92-6.36-.77-1.74a2.58,2.58,0,0,1-.23-.63,3.48,3.48,0,0,1,.34.58c.22.44.5,1,.86,1.7.76,1.54,1.8,3.67,3.07,6.28l10,20.8c3.86,8.11,7.36,15.45,9.92,20.84,1.25,2.61,2.27,4.75,3,6.31l.83,1.71A5.31,5.31,0,0,0,117.67,447.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,394a3.84,3.84,0,0,1-.35.53L116.23,396c-1,1.28-2.38,3.09-4.18,5.31-3.57,4.45-8.69,10.44-14.41,17s-10.88,12.5-14.53,16.87l-4.3,5.2-1.18,1.41a2.49,2.49,0,0,1-.44.47,3.84,3.84,0,0,1,.36-.54l1.09-1.47c1-1.28,2.38-3.1,4.17-5.31,3.58-4.45,8.69-10.44,14.41-17s10.88-12.5,14.53-16.88l4.31-5.19,1.17-1.42C117.5,394.14,117.65,394,117.67,394Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.34,381.94c-.18,2-24.56,84-24.56,84h5.74l26-82.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.91,379.74c.35,1.93-1.34,86.18-1.34,86.18h6.1l2.62-86.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,382.91c.18,2,24.21,83.35,24.21,83.35h-5.84l-26.41-82.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.88,299.36c.37,1,22.67,67.17,32.2,79.33s22.71,12.35,38.48,13c9.92.38,38.84,0,56.64-.3A15.07,15.07,0,0,0,184,376.69a46.57,46.57,0,0,1,.5-7.2c.66-1.65-3.36-29.55-7.63-35.14s-50.53-4.43-59.07-10.42-14.48-32.67-22.7-34.31S34.17,279.29,41.88,299.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.88,299.36s-.14-.34-.37-1a9.6,9.6,0,0,1-.44-3.12,6.73,6.73,0,0,1,.54-2.26,6.86,6.86,0,0,1,1.68-2.26,15.09,15.09,0,0,1,6.26-3c5.11-1.35,11.62-1.65,19.08-1.36a195.16,195.16,0,0,1,25.21,2.88,12.78,12.78,0,0,1,1.75.38,5.42,5.42,0,0,1,1.65.82A12.42,12.42,0,0,1,99.85,293a42.65,42.65,0,0,1,3.94,6.46c2.36,4.57,4.45,9.49,7,14.39a44.69,44.69,0,0,0,4.39,7.13,13,13,0,0,0,3,2.92,15.38,15.38,0,0,0,4,1.61,68.51,68.51,0,0,0,8.76,1.68c3,.42,6,.75,9.13,1.05,6.18.61,12.53,1.09,19,1.75,3.24.33,6.51.71,9.79,1.26a40.55,40.55,0,0,1,4.91,1.14,10,10,0,0,1,2.36,1,3.56,3.56,0,0,1,1,.89,8.46,8.46,0,0,1,.68,1.11,48.49,48.49,0,0,1,3.23,9.75c.81,3.35,1.49,6.75,2.09,10.2s1.12,6.93,1.49,10.46c.08.89.17,1.77.19,2.67,0,.23,0,.46,0,.7a2.11,2.11,0,0,1-.07.4,1.5,1.5,0,0,0-.07.27c-.07.42-.11.86-.15,1.3-.14,1.77-.2,3.55-.25,5.34a15.57,15.57,0,0,1-3.87,9.93,15.19,15.19,0,0,1-9.24,5,49,49,0,0,1-5.25.22l-5.18.08-10.23.13L130.6,392c-6.51,0-12.88,0-19.1-.2a121.27,121.27,0,0,1-18.12-1.57,32.35,32.35,0,0,1-15.45-7.19c-.53-.44-1-1-1.5-1.43l-.73-.73-.67-.78c-.43-.53-.91-1-1.29-1.58l-1.12-1.68a34.12,34.12,0,0,1-2-3.44c-.31-.58-.64-1.15-.93-1.73L68.85,370c-.55-1.16-1.13-2.29-1.65-3.44l-1.52-3.41c-1-2.24-1.91-4.48-2.83-6.64-7.14-17.4-12.18-31.76-15.69-41.67-1.72-5-3-8.82-3.95-11.45l-1-3c-.22-.67-.32-1-.32-1s.13.33.38,1l1.05,3c.92,2.62,2.28,6.46,4,11.41,3.57,9.88,8.67,24.23,15.84,41.6C64.12,358.5,65,360.73,66,363c.51,1.12,1,2.25,1.53,3.4s1.1,2.27,1.65,3.42l.84,1.74c.29.58.62,1.14.93,1.71a36.38,36.38,0,0,0,2,3.41l1.11,1.66c.38.55.86,1,1.28,1.55l.66.77c.24.25.49.48.73.72.49.46,1,1,1.48,1.41a32,32,0,0,0,15.25,7.07,123.82,123.82,0,0,0,18,1.54c6.21.23,12.58.19,19.08.18l19.92-.19,10.23-.14,5.18-.08a46.64,46.64,0,0,0,5.17-.22,14.58,14.58,0,0,0,8.93-4.83,15,15,0,0,0,3.74-9.59c.05-1.8.11-3.58.25-5.37,0-.45.08-.89.16-1.35a1.81,1.81,0,0,1,.09-.37,1,1,0,0,0,0-.26c0-.2,0-.42,0-.64,0-.87-.1-1.75-.19-2.63-.36-3.51-.89-7-1.48-10.42s-1.27-6.84-2.08-10.17a47.5,47.5,0,0,0-3.18-9.63,9.18,9.18,0,0,0-.64-1.05,2.93,2.93,0,0,0-.88-.76,9.57,9.57,0,0,0-2.24-1,40.23,40.23,0,0,0-4.83-1.12c-3.27-.56-6.53-.93-9.76-1.27-6.47-.66-12.82-1.15-19-1.76-3.09-.31-6.14-.64-9.15-1.06a70.86,70.86,0,0,1-8.82-1.71,16.28,16.28,0,0,1-4.11-1.67,13.31,13.31,0,0,1-3.15-3,45.17,45.17,0,0,1-4.42-7.21c-2.53-4.93-4.61-9.85-6.95-14.41a43,43,0,0,0-3.88-6.41A12.64,12.64,0,0,0,97,290.7a5.45,5.45,0,0,0-1.54-.78,15.22,15.22,0,0,0-1.71-.37,197.13,197.13,0,0,0-25.16-2.95c-7.44-.32-13.92-.05-19,1.26a14.94,14.94,0,0,0-6.21,3,6.33,6.33,0,0,0-2.21,4.41,9.5,9.5,0,0,0,.38,3.09c.1.34.19.6.24.77A2.53,2.53,0,0,1,41.88,299.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,434.05l11.27,32.74,40.39-14.92c-1.66-3.78-25.42-3.81-25.42-3.81L227.36,427Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.16,450.93a1.75,1.75,0,0,0-.44,2.3,1.69,1.69,0,0,0,2.28.46,1.85,1.85,0,0,0,.46-2.44A1.77,1.77,0,0,0,221,451",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,466.79l-1.3-3.4,39.39-12.86s2.09.13,2.35,1.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.88,447.62c.07.2-.89.65-1.62,1.64s-.95,2-1.16,2-.34-1.26.57-2.45S234.86,447.42,234.88,447.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,447.81c.12.17-.61.82-1,1.9s-.23,2-.43,2.1-.74-1-.26-2.34S239.69,447.62,239.76,447.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,452c-.16.11-.8-.78-.69-2.05s.87-2,1-1.9-.21.92-.28,2S244.23,451.9,244,452Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.77,443c0,.21-1,.27-2.11.76s-1.83,1.16-2,1,.42-1.15,1.7-1.7S232.8,442.8,232.77,443Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,438.55a4,4,0,0,1-2,.74,9.67,9.67,0,0,1-2.36.13,10.06,10.06,0,0,1-1.39-.19,2.64,2.64,0,0,1-.79-.25.9.9,0,0,1-.47-1,1.12,1.12,0,0,1,.69-.77,3,3,0,0,1,.8-.18,7.56,7.56,0,0,1,1.42,0,7.7,7.7,0,0,1,2.32.53c1.25.52,1.84,1.14,1.79,1.21s-.75-.36-2-.72a8.8,8.8,0,0,0-2.18-.35,8.16,8.16,0,0,0-1.29.07c-.47,0-.83.18-.87.41s0,.12.12.21a2.21,2.21,0,0,0,.58.18,13.08,13.08,0,0,0,1.3.22,11.16,11.16,0,0,0,2.23,0A15.05,15.05,0,0,1,230,438.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,438.93c-.06.05-.71-.51-1.25-1.76a7,7,0,0,1-.55-2.32,7.54,7.54,0,0,1,.06-1.41,1.8,1.8,0,0,1,.92-1.5,1,1,0,0,1,1.05.25,2.68,2.68,0,0,1,.48.66,5.09,5.09,0,0,1,.51,1.37,5,5,0,0,1-.09,2.41c-.41,1.33-1.14,1.87-1.18,1.81a19.75,19.75,0,0,0,.67-1.94,4.85,4.85,0,0,0-.06-2.13,4.42,4.42,0,0,0-.47-1.16c-.22-.4-.51-.69-.65-.59s-.43.52-.47.93a7.08,7.08,0,0,0-.09,1.28,7.51,7.51,0,0,0,.35,2.16C229.49,438.2,230,438.86,229.88,438.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.13,348.87c1.6.91,83.45,4.93,85.29,7.94,2.64,4.33,31.56,83.48,31.56,83.48l-29.74,9.35-30.77-67.9-73.18-2.19s-11.74-4.18-12-17.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,411.88l6.4,27.05,40.33-11.81c-1.36-3.79-24.5-5.41-24.5-5.41l-3.71-14.6Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.28,423.61a1.72,1.72,0,0,0-.59,2.22,1.65,1.65,0,0,0,2.19.6,1.81,1.81,0,0,0,.61-2.35,1.71,1.71,0,0,0-2.34-.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,438.93l-1-3.4,39.22-9.87s2,.27,2.18,1.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,421.31c0,.2-.91.58-1.69,1.49s-1.06,1.9-1.27,1.88-.24-1.25.73-2.35S235.85,421.12,235.86,421.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.6,421.82c.1.18-.65.76-1.08,1.79s-.36,2-.56,2-.65-1-.09-2.3S240.54,421.64,240.6,421.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.49,426.18c-.17.1-.73-.81-.54-2s1-1.93,1.11-1.79-.27.88-.41,1.89S244.68,426.11,244.49,426.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.11,416.66c0,.21-1,.2-2.1.6s-1.86,1-2,.87.47-1.09,1.77-1.54S234.16,416.48,234.11,416.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,412.16a4,4,0,0,1-2,.58,9.55,9.55,0,0,1-3.65-.31,2.66,2.66,0,0,1-.75-.29.9.9,0,0,1-.39-1,1.1,1.1,0,0,1,.73-.7,2.62,2.62,0,0,1,.79-.12,7.78,7.78,0,0,1,1.38.07,7.37,7.37,0,0,1,2.22.67c1.19.6,1.72,1.24,1.67,1.3s-.71-.4-1.87-.83a8.32,8.32,0,0,0-2.1-.49,7.62,7.62,0,0,0-1.27,0c-.46,0-.82.12-.87.34s0,.12.11.21a2.09,2.09,0,0,0,.55.22,10.13,10.13,0,0,0,1.24.3,11.69,11.69,0,0,0,2.17.17A14.49,14.49,0,0,1,231.75,412.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,412.51c-.06.06-.65-.54-1.1-1.79a6.93,6.93,0,0,1-.22-3.67,1.76,1.76,0,0,1,1-1.4,1,1,0,0,1,1,.32,2.73,2.73,0,0,1,.43.68,4.68,4.68,0,0,1,.4,1.36,5,5,0,0,1-.25,2.34c-.49,1.27-1.24,1.75-1.28,1.69a16.29,16.29,0,0,0,.79-1.84,4.78,4.78,0,0,0,.09-2.09,4.56,4.56,0,0,0-.38-1.15c-.19-.41-.45-.71-.6-.62s-.45.48-.51.87a6.87,6.87,0,0,0-.18,1.24,7.35,7.35,0,0,0,.2,2.13C231.25,411.78,231.67,412.45,231.57,412.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,420.53l26-7.12L213.67,341.6c-5.2-14.52-19.7-14-28.13-12.77l-61.14,5.81-4.31,15,68.1,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.43,420.53c1.62-.43,3-.85,4.64-1.27.31.79.32,1.7.62,2.5l.39,1.69c-1.3.45-3,.84-4.29,1.17a5.08,5.08,0,0,1-4.14-.78c-1.13-.92-1.55-2.62-1.9-4q-2.07-8.37-4.15-16.74c-2.36-9.55-7.9-20.2-8.15-30C198.3,388.44,206.43,404.88,210.43,420.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M120.44,218.26a2.78,2.78,0,0,0-1-1.61,6.86,6.86,0,0,0-4.26-1.05,17.83,17.83,0,0,1-1.74-5.65,3.66,3.66,0,0,0,2-.57,2.07,2.07,0,0,0,.33-.1c1.43-.66,1.57-2.8.67-4.08a8.13,8.13,0,0,0-3.91-2.52c1.08.07,2,.78,3,1.1s2.48,0,2.6-1.1a2.31,2.31,0,0,0-.16-1l-.6-1.9a2.17,2.17,0,0,0-.84-1.33,4.91,4.91,0,0,0-1.1-.26c-1.2-.33-1.83-1.79-3-2.13a5.52,5.52,0,0,0-2.69.4c-.89.21-2.08,0-2.36-.84a8.6,8.6,0,0,0,3.07-2.59,2.94,2.94,0,0,0-.29-3.7,4.32,4.32,0,0,0-3-.62c-1.18,0-2.64.32-2.95,1.46a3.06,3.06,0,0,0-3.76,2.4l-3-.31c.85-.91,2.05-1.46,2.78-2.47s.6-2.82-.62-3.08c-.44-.1-.93,0-1.35-.12s-.56-.4-.89-.41a1.18,1.18,0,0,0-.65.26l-6.41,4.18c.58-1.34,1.16-2.69,1.73-4s1-2.94-.16-3.71-2.64.33-2.86,1.61a2.09,2.09,0,0,0-2.54,1.92,2.11,2.11,0,0,0-2.48,3.22,6,6,0,0,0-3.05.91,1.83,1.83,0,0,0-3-1.26,3.27,3.27,0,0,0-.47-1.83,1.1,1.1,0,0,0-1.66-.18,2.14,2.14,0,0,0-3.47-2.1l-1.06-1.28a2.81,2.81,0,0,0-2.72,1.41c-.45,1,.3,2.41,1.38,2.32-.76,0-.59,1.2-.15,1.81L71.63,192a2.39,2.39,0,0,0-2.94-.26,1.85,1.85,0,0,0-2.66,0,1.49,1.49,0,0,0-2.67.45c-.19-.49-.87-.52-1.4-.47a3.55,3.55,0,0,0-2.12.73c-.54.54-.53,1.65.18,1.91-.65-.36-1.48.35-1.5,1.1a2.69,2.69,0,0,0,1.07,1.88A6.49,6.49,0,0,1,61.12,199a3.17,3.17,0,0,0-2.15-.46,8.19,8.19,0,0,0-3.87.78c-.23-.53-1-.55-1.52-.44A9.09,9.09,0,0,0,49,201.41c-.59.6-1.12,1.5-.72,2.24a2.21,2.21,0,0,0,.85.75L53.2,207a11.19,11.19,0,0,0-5.62,4c-.82.48-1.87.53-2.61,1.12s-.69,2.16.26,2.16a1.74,1.74,0,0,0-.5,2,1.66,1.66,0,0,0,.64.7,2.2,2.2,0,0,0,.45.51,3.16,3.16,0,0,0,1.1.58,2.16,2.16,0,0,0,1.84.85,8.83,8.83,0,0,0-1.95,2.32,3.65,3.65,0,0,0,0,3.77,1.14,1.14,0,0,0,.15.16,1.79,1.79,0,0,0,.78,1.14,1.56,1.56,0,0,0-.14,1,4,4,0,0,0-.9,7c.94.67,2.7.54,2.78-.61a3.17,3.17,0,0,0,2.38,1.73,3,3,0,0,0,1.58,4.16,3.23,3.23,0,0,0,1,5.28,2.47,2.47,0,1,0,4.66,1.62A5.33,5.33,0,0,0,61,248.81a1.82,1.82,0,0,0,2.56-.67,3.39,3.39,0,0,0,5,1.61,2.19,2.19,0,0,0,4.36.39l5.67-.06a20.34,20.34,0,0,0,3.74-.26,10.31,10.31,0,0,0,4.32-2,3.44,3.44,0,0,1,1.31-.8,3.48,3.48,0,0,1,1.73.27,9.18,9.18,0,0,0,8.71-2.06,4.61,4.61,0,0,1,1.15-.92,4.1,4.1,0,0,1,1.67-.23,16.4,16.4,0,0,0,4.12-.59,4.41,4.41,0,0,0,2.91-1.91c.54-1.06-.1-2.7-1.29-2.68a2.55,2.55,0,0,1,.63-2.16,1.53,1.53,0,0,1,2.09-.08,1.1,1.1,0,0,1-.51,1.8c1.29.89,3.28-.35,3.31-1.91a3.07,3.07,0,0,0-3.07-2.86,7.11,7.11,0,0,0,.09-3.43,2.51,2.51,0,0,0,3.43.39,4.3,4.3,0,0,0,2.81,2,2.59,2.59,0,0,0,2.87-1.56,1.88,1.88,0,0,0-1.78-2.42,2.24,2.24,0,0,0-2-3.24,3.48,3.48,0,0,0-2.12-3.69,1.83,1.83,0,0,0,2.6-1c.73,1.14,2.48.86,3.64.18A2.45,2.45,0,0,0,120.44,218.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44,218.26a1.52,1.52,0,0,1,.07.47,2,2,0,0,1-.44,1.3,4.42,4.42,0,0,1-1.88,1.3,3.82,3.82,0,0,1-1.47.24,1.82,1.82,0,0,1-1.49-.78l.12,0a1.92,1.92,0,0,1-2.72,1.06l.08-.15a3.59,3.59,0,0,1,2.19,3.79l-.11-.11a2.14,2.14,0,0,1,1.95,1,2.23,2.23,0,0,1,.15,2.35l-.11-.17a1.9,1.9,0,0,1,1.9,1.43,2.08,2.08,0,0,1-1,2.35,3,3,0,0,1-2.73.25,4.8,4.8,0,0,1-2.21-1.88l.19,0a2.66,2.66,0,0,1-3.63-.41l.25-.12a7.19,7.19,0,0,1-.08,3.5l-.14-.19a3.44,3.44,0,0,1,2.11.79,2.89,2.89,0,0,1,1.11,2,2.4,2.4,0,0,1-1.12,2.1,2.17,2.17,0,0,1-2.43.13l-.36-.25.43,0c.44,0,.71-.59.63-1.06a1,1,0,0,0-1.07-.78,1.5,1.5,0,0,0-1.29.78,2.6,2.6,0,0,0-.29,1.63l-.17-.15a1.45,1.45,0,0,1,1.12.53,2.13,2.13,0,0,1,.51,1.12,2.19,2.19,0,0,1-.16,1.23,2.88,2.88,0,0,1-.76,1,5.75,5.75,0,0,1-2.18,1.06,15.71,15.71,0,0,1-2.38.5c-1.6.33-3.46-.32-4.5,1.17A9.28,9.28,0,0,1,94,247.65a9.78,9.78,0,0,1-2.65.16,13.65,13.65,0,0,1-2.6-.57,1.57,1.57,0,0,0-1.17.13,9.52,9.52,0,0,0-1.06.78,10.73,10.73,0,0,1-2.41,1.35,14.58,14.58,0,0,1-5.53.79l-5.69.06.21-.18a2.41,2.41,0,0,1-4.79-.42l.35.18a3.62,3.62,0,0,1-5.33-1.72h.42a1.63,1.63,0,0,1-1.21,1,2.41,2.41,0,0,1-1.6-.18,5.41,5.41,0,0,1-2-2.44l.42,0a2.8,2.8,0,0,1-3.32,1.7,2.78,2.78,0,0,1-1.78-3.47l.15.29a3.22,3.22,0,0,1-2.06-2.45,3.27,3.27,0,0,1,1-3.23l.08.4a3.26,3.26,0,0,1-1.72-4.5l.18.35a3.4,3.4,0,0,1-2.56-1.86l.45-.08a1.2,1.2,0,0,1-.37.78,1.61,1.61,0,0,1-.74.39,2.76,2.76,0,0,1-1.58-.13,4,4,0,0,1-2-2.36,4.13,4.13,0,0,1,.17-3.16,4.33,4.33,0,0,1,2.34-2.19l-.15.27a1.76,1.76,0,0,1,.17-1.16l.09.32a2,2,0,0,1-.9-1.3l.06.11a3.57,3.57,0,0,1-.46-3.58,7.78,7.78,0,0,1,2.28-3l.18.42a2.36,2.36,0,0,1-2.05-.94l.12.08a3,3,0,0,1-1.68-1.18l.07.07a1.83,1.83,0,0,1-.89-1.48,2,2,0,0,1,.73-1.65l.15.44a.93.93,0,0,1-.76-.39,1.41,1.41,0,0,1-.25-.77,1.8,1.8,0,0,1,.6-1.44c.84-.65,1.88-.69,2.64-1.14l-.08.07a11.5,11.5,0,0,1,5.75-4.08l-.06.44L51.19,206l-1.43-.89a11.42,11.42,0,0,1-1.43-.95,1.46,1.46,0,0,1-.46-.87,1.85,1.85,0,0,1,.15-.94,4.05,4.05,0,0,1,1.07-1.4A9.24,9.24,0,0,1,52,199.13a8.77,8.77,0,0,1,1.63-.48,2.31,2.31,0,0,1,.91,0,1.1,1.1,0,0,1,.82.6l-.35-.11a7,7,0,0,1,3.12-.77c.53,0,1-.06,1.58,0a2.6,2.6,0,0,1,1.6.51l-.37.3c-.46-.91-1.58-1.39-2.24-2.41a1.82,1.82,0,0,1-.22-1.81,1.54,1.54,0,0,1,.68-.68,1.08,1.08,0,0,1,1,0l-.2.44a1.1,1.1,0,0,1-.65-.7,1.59,1.59,0,0,1,0-.89,1.57,1.57,0,0,1,.46-.77,2.15,2.15,0,0,1,.72-.44,5.76,5.76,0,0,1,1.56-.31,2.62,2.62,0,0,1,.83,0,1,1,0,0,1,.74.59l-.46.06a1.73,1.73,0,0,1,3.13-.53l-.4,0a2.08,2.08,0,0,1,3,0l-.32,0a2.59,2.59,0,0,1,3.24.28l-.35.31L69.86,190a3,3,0,0,1-.65-1.26,1.58,1.58,0,0,1,0-.78.77.77,0,0,1,.25-.39.74.74,0,0,1,.46-.15l0,.47a1.6,1.6,0,0,1-1.52-.93,2,2,0,0,1-.07-1.76,3,3,0,0,1,2.92-1.5h.1l.07.08,1.06,1.28-.33,0A2.38,2.38,0,0,1,76,187.34l-.41-.19a1.15,1.15,0,0,1,1.1-.36,1.52,1.52,0,0,1,.94.58,3.44,3.44,0,0,1,.49,1.93l-.38-.15a2.06,2.06,0,0,1,3.35,1.43l-.35-.2a6.26,6.26,0,0,1,3.17-.94l-.18.36a2.33,2.33,0,0,1,2.75-3.56l-.31.2A2.3,2.3,0,0,1,89,184.31l-.28.17a2.7,2.7,0,0,1,.86-1.45,2.23,2.23,0,0,1,1.59-.57,1.69,1.69,0,0,1,1.36,1,3,3,0,0,1,.13,1.63,14,14,0,0,1-1,2.89c-.4.92-.8,1.83-1.19,2.74l-.3-.26,4-2.57L96,186.64a4.74,4.74,0,0,1,1-.6.91.91,0,0,1,.69.11,5,5,0,0,0,.48.27,3,3,0,0,0,1,.09,1.49,1.49,0,0,1,1.12.54,2.45,2.45,0,0,1,.22,2.31,4.15,4.15,0,0,1-1.46,1.71,13.88,13.88,0,0,0-1.64,1.35l-.12-.32,3,.31-.2.16a3.25,3.25,0,0,1,4-2.55l-.23.13a2.08,2.08,0,0,1,1.54-1.35,7.81,7.81,0,0,1,2-.25,5.76,5.76,0,0,1,1.93.21,2.42,2.42,0,0,1,1.46,1.29,3.54,3.54,0,0,1-.63,3.57,10.26,10.26,0,0,1-2.79,2.17l.07-.19a1.25,1.25,0,0,0,1,.78,3.08,3.08,0,0,0,1.44-.13,10.18,10.18,0,0,1,1.47-.36,2.24,2.24,0,0,1,1.5.29c.88.53,1.39,1.4,2.19,1.78.38.21.84.15,1.32.34a1.77,1.77,0,0,1,.9,1.1c.27.86.53,1.69.79,2.5a1.56,1.56,0,0,1-.1,1.33,1.73,1.73,0,0,1-1.09.71,2.69,2.69,0,0,1-1.26,0,5.85,5.85,0,0,1-1.13-.42,6.18,6.18,0,0,0-2.09-.74l0-.23a15.36,15.36,0,0,1,2.48,1.19,4.68,4.68,0,0,1,1.75,1.87A3.37,3.37,0,0,1,117,208a2.07,2.07,0,0,1-1.5,1.5h0a3.63,3.63,0,0,1-2.06.58l.09-.09a18.4,18.4,0,0,0,1.71,5.63l0,0a10.23,10.23,0,0,1,2.84.34,4.1,4.1,0,0,1,1.73,1,2.73,2.73,0,0,1,.6,1,1.25,1.25,0,0,1,.09.37,2.78,2.78,0,0,0-.74-1.33,3.94,3.94,0,0,0-1.7-1,10.93,10.93,0,0,0-2.82-.31h0l0,0a18.07,18.07,0,0,1-1.77-5.66v-.1h.1a3.43,3.43,0,0,0,2-.56h0a1.9,1.9,0,0,0,1.36-1.38,3.18,3.18,0,0,0-.17-2.2,4.45,4.45,0,0,0-1.67-1.76,15,15,0,0,0-2.45-1.16l-.7-.27.75,0a6.33,6.33,0,0,1,2.19.75,5.41,5.41,0,0,0,1.08.4,2.58,2.58,0,0,0,1.14,0,1.48,1.48,0,0,0,.93-.6,1.29,1.29,0,0,0,.06-1.11c-.26-.81-.53-1.63-.8-2.48a1.41,1.41,0,0,0-.74-.93,11.67,11.67,0,0,1-1.34-.35c-.9-.44-1.42-1.32-2.21-1.78s-1.79-.17-2.74.12a3.59,3.59,0,0,1-1.57.13,1.58,1.58,0,0,1-1.31-1l0-.12.11-.07a10,10,0,0,0,2.7-2.1,3.2,3.2,0,0,0,.57-3.22,2,2,0,0,0-1.25-1.1,5.42,5.42,0,0,0-1.81-.19,7.19,7.19,0,0,0-1.86.24,1.75,1.75,0,0,0-1.3,1.1l0,.19-.18-.06a2.88,2.88,0,0,0-3.52,2.26l0,.17h-.17l-3-.31-.38,0,.26-.28a14.57,14.57,0,0,1,1.68-1.39,4,4,0,0,0,1.34-1.55,2.09,2.09,0,0,0-.17-1.92,1,1,0,0,0-.83-.39,3.36,3.36,0,0,1-1.18-.12c-.4-.2-.65-.45-.91-.36a5.49,5.49,0,0,0-.93.54l-1.93,1.27-4,2.58-.58.38.27-.63c.39-.91.78-1.83,1.18-2.75a13.6,13.6,0,0,0,1-2.79,2.59,2.59,0,0,0-.1-1.39,1.27,1.27,0,0,0-1-.75,2.07,2.07,0,0,0-2,1.67l0,.24-.23-.07a1.87,1.87,0,0,0-2.26,1.71v.33l-.31-.13a1.89,1.89,0,0,0-2.22,2.89l.26.35h-.43a5.78,5.78,0,0,0-2.94.87l-.36.23,0-.42a1.62,1.62,0,0,0-2.58-1.1l-.36.36,0-.51a3,3,0,0,0-.41-1.68c-.29-.41-1-.57-1.31-.2l-.63.85.23-1a1.92,1.92,0,0,0-3.1-1.88l-.18.15-.15-.18-1.06-1.27.17.08a2.62,2.62,0,0,0-2.48,1.24c-.42.8.22,2.11,1.13,2v.47c-.14,0-.2.05-.25.21a1.1,1.1,0,0,0,0,.54,2.7,2.7,0,0,0,.58,1.09l1.57,2.18-.35.32a2.15,2.15,0,0,0-2.64-.25l-.18.14-.14-.17a1.6,1.6,0,0,0-2.3,0l-.24.29-.15-.34a1.25,1.25,0,0,0-2.22.37l-.11,1.2-.36-1.14c-.09-.31-.62-.37-1.08-.32a5.42,5.42,0,0,0-1.42.28,1.31,1.31,0,0,0-.89.88.84.84,0,0,0,.36,1l-.2.43c-.33-.2-.83.08-1,.49a1.34,1.34,0,0,0,.2,1.33c.53.87,1.66,1.34,2.26,2.45l.57,1-.94-.76c-.7-.56-1.83-.38-2.84-.36a6.47,6.47,0,0,0-2.9.71l-.25.14-.1-.25c-.13-.35-.71-.4-1.19-.31a9.38,9.38,0,0,0-1.54.46,8.9,8.9,0,0,0-2.72,1.72,3.71,3.71,0,0,0-1,1.23,1.05,1.05,0,0,0,.2,1.27,11.28,11.28,0,0,0,1.35.89l1.43.88,1.88,1.17.46.28-.51.16a11,11,0,0,0-5.5,3.9l0,0,0,0c-.91.51-1.91.56-2.57,1.1a1.27,1.27,0,0,0-.42,1c0,.39.21.71.52.69l.77-.05-.62.48a1.49,1.49,0,0,0-.54,1.25,1.3,1.3,0,0,0,.66,1.09l0,0,0,0a2.57,2.57,0,0,0,1.43,1l.07,0,0,.07a1.92,1.92,0,0,0,1.62.75l.73-.07-.54.49a7.44,7.44,0,0,0-2.16,2.81,3.11,3.11,0,0,0,.37,3.1l0,.05v.06a1.55,1.55,0,0,0,.68,1l.19.12-.1.2a1.34,1.34,0,0,0-.13.84l.05.2-.2.08a3.82,3.82,0,0,0-2.08,1.95,3.61,3.61,0,0,0-.15,2.79,3.54,3.54,0,0,0,1.76,2.07,2.21,2.21,0,0,0,1.29.12.87.87,0,0,0,.75-.75l0-.92.4.84a2.89,2.89,0,0,0,2.19,1.59l.35.05-.18.3a2.8,2.8,0,0,0,1.46,3.83l.41.13-.34.27a2.82,2.82,0,0,0-.81,2.77,2.76,2.76,0,0,0,1.75,2.11l.22.07-.08.23a2.24,2.24,0,0,0,4.24,1.47l.17-.51.24.48a5,5,0,0,0,1.82,2.25,1.58,1.58,0,0,0,2.18-.58l.22-.64.2.65a3.18,3.18,0,0,0,4.65,1.51l.36-.27v.45a2,2,0,0,0,1.89,2,2.07,2.07,0,0,0,2-1.67l0-.18h.19l5.68,0a14.21,14.21,0,0,0,5.39-.75,10.16,10.16,0,0,0,2.32-1.3,8.82,8.82,0,0,1,1.11-.81,2,2,0,0,1,1.44-.17,12.75,12.75,0,0,0,2.55.57,9.06,9.06,0,0,0,2.55-.14A8.82,8.82,0,0,0,98.3,245a5.16,5.16,0,0,1,1-.82,2.81,2.81,0,0,1,1.28-.29,21.42,21.42,0,0,0,2.43-.15,15.29,15.29,0,0,0,2.33-.48,5.42,5.42,0,0,0,2.05-1,2,2,0,0,0,.8-1.88,1.43,1.43,0,0,0-1.28-1.35h-.15l0-.15a3,3,0,0,1,.33-1.85,1.86,1.86,0,0,1,1.58-.95,1.32,1.32,0,0,1,1.41,1.07,1.22,1.22,0,0,1-.91,1.44l.07-.3a1.85,1.85,0,0,0,2.06-.12,2.1,2.1,0,0,0,1-1.83,3,3,0,0,0-2.91-2.54h-.2l0-.19a7,7,0,0,0,.1-3.35l-.14-.61.39.49a2.39,2.39,0,0,0,3.23.37l.12-.1.08.13a4.55,4.55,0,0,0,2.08,1.79,2.71,2.71,0,0,0,2.51-.22,1.81,1.81,0,0,0,.86-2.07,1.65,1.65,0,0,0-1.65-1.28l-.22,0,.12-.2a2.14,2.14,0,0,0-1.89-3.08h-.12l0-.12a3.42,3.42,0,0,0-2.06-3.61l.07-.14a1.77,1.77,0,0,0,2.5-1l0-.15.08.13a1.69,1.69,0,0,0,1.39.74,3.59,3.59,0,0,0,1.42-.22A4.39,4.39,0,0,0,120,220a2,2,0,0,0,.45-1.26C120.47,218.42,120.43,218.27,120.44,218.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.08,259.62c-.1-3-.16-5.35-.14-5.35s10.21-1.46,10.46-11.66c.12-4.92-.47-15.07-1.1-24.25a19,19,0,0,0-18.73-17.69h-1C74,201.15,68.47,210.44,69.26,221l1.08,38.77,6,14.76c6,6.61,19-6,18.7-14.95Z",
    style: {
      fill: "#db8a76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,254.27a24.66,24.66,0,0,1-13.23-4.08s3,7.81,13.23,7Z",
    style: {
      fill: "#9a5d53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,227.43a1.44,1.44,0,0,1-1.42,1.45,1.39,1.39,0,0,1-1.48-1.33,1.45,1.45,0,0,1,1.42-1.45A1.38,1.38,0,0,1,100.36,227.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,222.55c-.18.19-1.27-.64-2.84-.66s-2.72.76-2.89.57.1-.43.61-.79a3.91,3.91,0,0,1,2.31-.68,3.72,3.72,0,0,1,2.26.76C102.06,222.12,102.22,222.47,102.13,222.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.55,228.18a1.46,1.46,0,0,1-1.43,1.45,1.38,1.38,0,0,1-1.48-1.33,1.46,1.46,0,0,1,1.42-1.45A1.4,1.4,0,0,1,86.55,228.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,223c-.18.18-1.28-.65-2.84-.66s-2.73.76-2.89.56.1-.42.61-.78a4,4,0,0,1,2.31-.69,3.85,3.85,0,0,1,2.26.76C86.71,222.58,86.87,222.92,86.78,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.26,235.11a10.07,10.07,0,0,1,2.55-.43c.4,0,.78-.11.85-.39a2.1,2.1,0,0,0-.25-1.19c-.37-1-.75-2-1.15-3-1.59-4.36-2.74-7.94-2.57-8s1.61,3.41,3.21,7.77c.38,1.07.75,2.1,1.09,3.08a2.29,2.29,0,0,1,.19,1.57,1,1,0,0,1-.66.58,3,3,0,0,1-.68.08A10.18,10.18,0,0,1,92.26,235.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,217.72c-.16.42-1.72.2-3.56.41s-3.33.69-3.57.3c-.11-.18.16-.58.76-1a6.15,6.15,0,0,1,2.65-.9,5.91,5.91,0,0,1,2.78.36C86.94,217.18,87.28,217.52,87.21,217.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,217.28c-.27.36-1.35,0-2.65,0s-2.4.27-2.65-.1c-.11-.18,0-.54.53-.88a3.74,3.74,0,0,1,2.15-.61,3.65,3.65,0,0,1,2.12.7C101.53,216.74,101.68,217.1,101.56,217.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,239.14a6.28,6.28,0,0,1-.77,1.71,2.21,2.21,0,0,1-1.53,1,2,2,0,0,1-1.73-.83,3.19,3.19,0,0,1-.56-1.9c0-.6.24-1.34.83-1.44a1.59,1.59,0,0,1,.74.13L94,238.92",
    style: {
      fill: "#9a5d53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.64,241.79a4.34,4.34,0,0,1-1.69-.12,2.41,2.41,0,0,1-1.33-1.1,2.52,2.52,0,0,1-.14-2.06,2.42,2.42,0,0,1,.25-.48c.12-.14.1-.13.23-.12s.35.12.52.17l.53.19,1.83.62a6.05,6.05,0,0,0,1.75.43,5.94,5.94,0,0,0-1.61-.81l-1.79-.73-.52-.2c-.19-.07-.34-.14-.59-.21a.71.71,0,0,0-.47,0,.8.8,0,0,0-.33.29,2.4,2.4,0,0,0-.33.61,3,3,0,0,0,.22,2.52,2.69,2.69,0,0,0,1.66,1.22,2.57,2.57,0,0,0,1.37,0C92.51,241.94,92.65,241.82,92.64,241.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,209.88a11.07,11.07,0,0,0-.23-1.53,4.57,4.57,0,0,0-1.35-1.9c-2-1.91-4-3.89-6.45-4.52-1.5-.39-3-.24-4.55-.61a26.81,26.81,0,0,1-2.72-1,22.22,22.22,0,0,0-11.55-.62,18.39,18.39,0,0,0-6.21,2,22.31,22.31,0,0,0-5.56,5.06,34,34,0,0,0-6.2,10,16.64,16.64,0,0,0-.89,9.42c.74,3.14,3,6,5.68,6.39l.94-1.29,1.52-1.91c-.25.76,0,.71.63,1.07a1.3,1.3,0,0,0,1.8-.67c.55.62,1.62-.15,1.39-1,.64.29,1.36-.59,1.1-1.34.73.21,1.06-1,1.36-1.76.17-.43.42-.81.63-1.22a7.9,7.9,0,0,0,.8-4.34,7.75,7.75,0,0,0,1-4.26c0-.95.07-1.89.11-2.83l.46-.69a1.52,1.52,0,0,0,1.13,1.36,3.3,3.3,0,0,0,1.7-.16l1.64-.47,1.07.22a4.19,4.19,0,0,0,.53,2.7,2.63,2.63,0,0,0,1.09,1.44.79.79,0,0,0,1-.94.88.88,0,0,0,1.34-.32,2.89,2.89,0,0,0,.23-1.76,7.3,7.3,0,0,0-1.67-3.94l3.13,2.48a1.39,1.39,0,0,0,.74.38.77.77,0,0,0,.89.78,2,2,0,0,0,1-.82c.64-.8,1.29-2.12.59-2.91a.63.63,0,0,0,.21-.94l3.5,2.24c-.35-.17-.67.37-.56.79a1.81,1.81,0,0,0,.77.93,2.61,2.61,0,0,0-.26,1.59c-.63-.48-1.44.58-1.18,1.41a1.86,1.86,0,0,0,1.85,1.22,1.29,1.29,0,0,0,1.39-1.08c.74.09,1.36-1,1-1.75.55.3.94-.68.91-1.39a10.23,10.23,0,0,0-.83-3.63.19.19,0,0,0,.27.06.2.2,0,0,0,.06-.15l2.09,4.1a10.68,10.68,0,0,1,1.33,3.69c0,.54.17,1.27.63,1.28a.57.57,0,0,0,.35-.12,6.77,6.77,0,0,0,2.69-3.7,5.31,5.31,0,0,0,.33-1.63A21.68,21.68,0,0,0,107,209.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,208.46a1.7,1.7,0,0,0,.35-.85,1.1,1.1,0,0,0-.37-.92,1.17,1.17,0,0,0-1.22-.2l-.25.11.09-.27a1.26,1.26,0,0,0-.45-1.36,1.24,1.24,0,0,0-1.56.19l-.22-.17a.51.51,0,0,0,.07-.17.69.69,0,0,0-.15-.58.84.84,0,0,0-.54-.28,1.3,1.3,0,0,0-.62.08,1.65,1.65,0,0,1-.69.22c-.31,0-.46-.24-.62-.33a2.73,2.73,0,0,0-.51-.26,2.8,2.8,0,0,0-2.46.34c-.3.2-.43.37-.45.35a1.16,1.16,0,0,1,.38-.44,2.84,2.84,0,0,1,2.6-.47,2.76,2.76,0,0,1,.58.27c.19.12.34.28.49.28a1.79,1.79,0,0,0,.58-.21,1.6,1.6,0,0,1,.76-.11,1.07,1.07,0,0,1,.72.38,1,1,0,0,1,.21.83.88.88,0,0,1-.12.26l-.22-.18a1.49,1.49,0,0,1,1.93-.22,1.48,1.48,0,0,1,.51,1.66l-.16-.15a1.39,1.39,0,0,1,1.46.29,1.3,1.3,0,0,1,.08,1.75A.89.89,0,0,1,92.46,208.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,209.67a2.06,2.06,0,0,0,.46-.83,1.43,1.43,0,0,0-.15-1.06,1.46,1.46,0,0,0-1.17-.7h-.21l.13-.17a1.75,1.75,0,0,0,.34-1.57.94.94,0,0,0-.61-.59.78.78,0,0,0-.83.18l-.72.92.49-1.06a1.43,1.43,0,0,0,0-1.23,1.41,1.41,0,0,0-2-.57l-.32.18.11-.35c.15-.5-.39-1-.88-1a2.41,2.41,0,0,0-1.46.5l-.26.17.06-.3a1,1,0,0,0-.42-1,1.86,1.86,0,0,0-1-.35,4.76,4.76,0,0,0-1.8.2,7.72,7.72,0,0,0-1.46.67,1.29,1.29,0,0,1,.33-.27,4.8,4.8,0,0,1,1.08-.55,4.94,4.94,0,0,1,1.87-.26,2.13,2.13,0,0,1,1.12.37,1.29,1.29,0,0,1,.54,1.21l-.2-.13a2.64,2.64,0,0,1,1.62-.56,1.31,1.31,0,0,1,.86.42,1,1,0,0,1,.27,1l-.21-.17a1.67,1.67,0,0,1,1.12-.21,1.63,1.63,0,0,1,1.25.91,1.72,1.72,0,0,1,0,1.47l-.23-.15a1,1,0,0,1,1.12-.26,1.22,1.22,0,0,1,.77.75,2,2,0,0,1-.41,1.79l-.08-.17a1.63,1.63,0,0,1,1.31.84,1.55,1.55,0,0,1,.12,1.17,1.48,1.48,0,0,1-.37.65C99.7,209.64,99.62,209.68,99.62,209.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83,209.68a1,1,0,0,0-.43-.74,1.36,1.36,0,0,0-1-.26,3.82,3.82,0,0,0-1.31.44l-.16.07V209a1.22,1.22,0,0,0-1.09-1.1,3.56,3.56,0,0,0-2,.49l-.84.4.7-.62a1,1,0,0,0-.2-1.43,2.27,2.27,0,0,0-1.79-.26h-.08l-.55.1.43-.35a1.08,1.08,0,0,0-.26-1.68,1.62,1.62,0,0,0-1.79.33l-.54.5.33-.66a2.43,2.43,0,0,0-.22-2.47,2.26,2.26,0,0,0-1.75-.91,2.6,2.6,0,0,0-1.31.28c-.28.15-.41.27-.43.25l.09-.09a1.87,1.87,0,0,1,.3-.23,2.52,2.52,0,0,1,3.28.57,2.69,2.69,0,0,1,.28,2.72l-.21-.15a1.89,1.89,0,0,1,2.1-.39,1.36,1.36,0,0,1,.69,1,1.19,1.19,0,0,1-.38,1.17l-.12-.25h.09a2.52,2.52,0,0,1,2,.32,1.48,1.48,0,0,1,.5.9,1,1,0,0,1-.3.95l-.15-.22a3.77,3.77,0,0,1,2.12-.49,1.44,1.44,0,0,1,1.26,1.35l-.15-.1a4.12,4.12,0,0,1,1.39-.41,1.45,1.45,0,0,1,1,.33,1,1,0,0,1,.37.59C114.86,209.6,114.84,209.68,114.83,209.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.68,196s-.11.09-.36.17a5.69,5.69,0,0,1-1.09.15,3.23,3.23,0,0,0-1.56.37,1,1,0,0,0-.49.73.73.73,0,0,0,.36.81l-.18.15c-.09-.36-.56-.55-1-.75a4.71,4.71,0,0,0-1.37-.46,1.75,1.75,0,0,0-1.33.32,1.16,1.16,0,0,0-.49,1.1l.08.34L98,198.7a3.13,3.13,0,0,0-1.91-.6,3.7,3.7,0,0,0-1.56.36,4.3,4.3,0,0,0-1.14.88,1.07,1.07,0,0,1,.21-.33,3,3,0,0,1,.86-.69,3.45,3.45,0,0,1,1.63-.44,3.34,3.34,0,0,1,2.07.61l-.21.13a1.42,1.42,0,0,1,.58-1.37,2,2,0,0,1,1.54-.38,5.15,5.15,0,0,1,1.45.48,5.84,5.84,0,0,1,.65.35,1,1,0,0,1,.47.6l.07.26-.25-.11a1,1,0,0,1-.5-1.08,1.25,1.25,0,0,1,.62-.89,3.33,3.33,0,0,1,1.67-.35,6,6,0,0,0,1.08-.07C105.55,196,105.67,196,105.68,196Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,191.76a3.19,3.19,0,0,0-.73.17,1.83,1.83,0,0,0-.67.5,1.56,1.56,0,0,0-.37,1v.16l-.15,0a.94.94,0,0,0-1,.67,2.81,2.81,0,0,0,.08,1.56l.13.55-.38-.42-.06-.07a1.24,1.24,0,0,0-1-.32,1.36,1.36,0,0,0-.89.48,2.14,2.14,0,0,0-.42,1.72,3.74,3.74,0,0,0,.42,1.2,2.1,2.1,0,0,1,.21.42,1.38,1.38,0,0,1-.31-.37,3.47,3.47,0,0,1-.52-1.21,2.34,2.34,0,0,1,.42-1.93,1.59,1.59,0,0,1,2.3-.19l.08.09-.25.12a3.06,3.06,0,0,1-.06-1.72,1.18,1.18,0,0,1,1.3-.81l-.15.11a1.71,1.71,0,0,1,.46-1.11,1.78,1.78,0,0,1,.77-.51,1.38,1.38,0,0,1,.58-.09C91.14,191.73,91.2,191.75,91.2,191.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.59,201.4s-.15,0-.38-.05a2.27,2.27,0,0,1-.91-.53,2.51,2.51,0,0,1-.77-1.36c0-.29-.06-.59-.25-.76s-.53-.28-.77-.59a1.42,1.42,0,0,1,.2-1.94v.21a4.6,4.6,0,0,1-1.35-1.57,1.69,1.69,0,0,1-.26-.76s.14.26.4.68a5.06,5.06,0,0,0,1.36,1.44l.15.1-.14.11a1.17,1.17,0,0,0-.14,1.56c.16.23.48.31.75.57a1.42,1.42,0,0,1,.31.9,2.48,2.48,0,0,0,.65,1.27A3.49,3.49,0,0,0,79.59,201.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.16,204.2s-.08,0-.23.06a3,3,0,0,1-.68,0,3.8,3.8,0,0,1-2.19-1l.18,0a2.42,2.42,0,0,1-1.59,1,2.38,2.38,0,0,1-1.06,0,1.52,1.52,0,0,1-1-.63,1.85,1.85,0,0,1-.15-.4.52.52,0,0,0-.2-.24,1.77,1.77,0,0,0-.68-.24,2.32,2.32,0,0,1-.75-.23.81.81,0,0,1-.46-.67l.19.11a2.48,2.48,0,0,1-1.73.19,2.62,2.62,0,0,1-1.19-.61,2.15,2.15,0,0,1-.53-.69.67.67,0,0,1-.1-.29,3.89,3.89,0,0,0,.73.86,2.57,2.57,0,0,0,1.14.52,2.26,2.26,0,0,0,1.55-.2l.19-.1v.21a.55.55,0,0,0,.34.43,2,2,0,0,0,.67.2,1.88,1.88,0,0,1,.79.28.79.79,0,0,1,.3.37,2.73,2.73,0,0,0,.14.36,1.29,1.29,0,0,0,.78.5A2.29,2.29,0,0,0,73,203.1l.08-.12.11.1a3.78,3.78,0,0,0,2,1C75.83,204.22,76.16,204.17,76.16,204.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.56,214.83s0,0,0-.1a1.76,1.76,0,0,1-.07-.29,2.92,2.92,0,0,1,0-1.13,8.88,8.88,0,0,1,1.18-2.61,1.86,1.86,0,0,1,.46-.42.78.78,0,0,1,.7-.06l-.17.13a1.89,1.89,0,0,1,2.93-1.9l-.22.13a1.28,1.28,0,0,1,.43-1.1,1.29,1.29,0,0,1,1.79.12l-.25.12a.86.86,0,0,1,.24-.7,1.16,1.16,0,0,1,.62-.32,2.52,2.52,0,0,1,1.24.21l-.17.07a2,2,0,0,1,1.15-1,2.78,2.78,0,0,1,1.39-.12,7.07,7.07,0,0,1,2.23.88l-.14.14a.5.5,0,0,1,0-.5.93.93,0,0,1,.33-.3,1.45,1.45,0,0,1,.74-.18,4.1,4.1,0,0,1,1.16.25,3.25,3.25,0,0,1,.67.32.67.67,0,0,1,.21.16,8.69,8.69,0,0,0-.92-.37,4.2,4.2,0,0,0-1.12-.19,1.43,1.43,0,0,0-.65.17c-.21.12-.37.34-.25.54l.18.3-.32-.16a7.26,7.26,0,0,0-2.17-.82,2.6,2.6,0,0,0-1.26.12,1.78,1.78,0,0,0-1,.84l-.06.11-.11,0a2.27,2.27,0,0,0-1.1-.19c-.34.05-.68.37-.63.69l.09.49-.33-.37a.93.93,0,0,0-.46-.29,1,1,0,0,0-.93.19,1,1,0,0,0-.34.86l0,.31-.25-.18a1.67,1.67,0,0,0-1.88,0,1.71,1.71,0,0,0-.66,1.61l0,.23-.21-.1c-.32-.15-.67.13-.89.4a7.75,7.75,0,0,0-.55.9,7.35,7.35,0,0,0-.66,1.6A3.6,3.6,0,0,0,54.56,214.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.86,223a.61.61,0,0,1-.16-.17,3.39,3.39,0,0,1-.38-.54,1.93,1.93,0,0,1-.32-1,1.56,1.56,0,0,1,.16-.67,1.12,1.12,0,0,1,.58-.53l-.05.16a1.33,1.33,0,0,1,1.24-2.15l-.11.21a1.07,1.07,0,0,1-.07-1.26,1.59,1.59,0,0,1,1.16-.67,5.2,5.2,0,0,0,.63,0,.54.54,0,0,0,.37-.38,2.48,2.48,0,0,1,.31-.64,1.19,1.19,0,0,1,.64-.42,6.7,6.7,0,0,1,1.5-.17,1.63,1.63,0,0,0,1.19-.46c.13-.16.22-.37.35-.57a1.38,1.38,0,0,1,.53-.49,1.49,1.49,0,0,1,1.33,0l-.15.19a1.12,1.12,0,0,1,0-1.31,1.64,1.64,0,0,1,1-.62,5.12,5.12,0,0,1,1.87.07,6.48,6.48,0,0,1,1.15.35,2.09,2.09,0,0,1,.38.19s-.55-.22-1.55-.4a5.44,5.44,0,0,0-1.81,0,1.44,1.44,0,0,0-.87.54.9.9,0,0,0,0,1l.34.42-.49-.23a1.25,1.25,0,0,0-1.1.05,1,1,0,0,0-.43.4,6.79,6.79,0,0,1-.36.6,1.57,1.57,0,0,1-.64.44,3.29,3.29,0,0,1-.74.13,6.78,6.78,0,0,0-1.45.16.94.94,0,0,0-.49.33,1.74,1.74,0,0,0-.28.58.86.86,0,0,1-.55.53,6.34,6.34,0,0,1-.67.06,1.33,1.33,0,0,0-1,.53.81.81,0,0,0,0,1l.24.27-.36-.06a1.13,1.13,0,0,0-1.16.6,1.15,1.15,0,0,0,.12,1.18l.09.11-.14,0a1.09,1.09,0,0,0-.64,1,2.1,2.1,0,0,0,.25,1C56.68,222.72,56.88,223,56.86,223Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,238.37a.68.68,0,0,1-.28-.06,2,2,0,0,1-.69-.46,2,2,0,0,1-.58-1.16,2.18,2.18,0,0,1,.44-1.63v.16a4,4,0,0,1-.86-1.35,1.65,1.65,0,0,1,0-.91,1.19,1.19,0,0,1,.62-.76v.25a1.66,1.66,0,0,1-.84-1.42,1.85,1.85,0,0,1,.22-.95,1.55,1.55,0,0,1,.68-.64c.26-.15.37-.28.36-.56a2.2,2.2,0,0,1,.12-.84,2.84,2.84,0,0,1,1-1.22c.35-.31.68-.6,1-.86a4.66,4.66,0,0,1,1.66-1,2.16,2.16,0,0,1,.52-.09c.12,0,.18,0,.18,0a5.43,5.43,0,0,0-.67.17,5.22,5.22,0,0,0-1.56,1l-1,.88a2.67,2.67,0,0,0-.86,1.13,1.9,1.9,0,0,0-.1.76.8.8,0,0,1-.12.48,1.11,1.11,0,0,1-.37.32,1.47,1.47,0,0,0-.07,2.52l.25.13-.26.12a1.14,1.14,0,0,0-.46,1.34,3.84,3.84,0,0,0,.79,1.27l.06.08-.06.07a1.94,1.94,0,0,0,.05,2.55A2.53,2.53,0,0,0,56,238.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,213.37a2.26,2.26,0,0,1-.87-.27,2.43,2.43,0,0,1-.82-.59,1.6,1.6,0,0,1-.38-1.21,1.11,1.11,0,0,1,.09-.31l.08.19a1.36,1.36,0,0,1-.78-.87,1.22,1.22,0,0,1,.1-.94c.27-.48.64-.55.63-.52a2.07,2.07,0,0,0-.45.61,1.06,1.06,0,0,0,0,.77,1.17,1.17,0,0,0,.64.69l.13.05,0,.14a.88.88,0,0,0-.07.23,1.35,1.35,0,0,0,.31,1,2.19,2.19,0,0,0,.7.58C79.43,213.19,79.76,213.32,79.74,213.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,209.75a1.72,1.72,0,0,0,.11-1.06,1.22,1.22,0,0,0-.75-.83,1.28,1.28,0,0,0-1.33.33l-.17.18-.06-.23a2.36,2.36,0,0,0-.4-.81,1.09,1.09,0,0,0-.75-.45c-.46,0-.93.45-.77.81l-.26.08a2.2,2.2,0,0,0-.9-1.35,2.11,2.11,0,0,0-1.26-.36,3.09,3.09,0,0,0-1.17.32s.08-.1.27-.22a2,2,0,0,1,.89-.27,2.25,2.25,0,0,1,1.4.33,2.36,2.36,0,0,1,1,1.49l-.26.08a.82.82,0,0,1,.21-.85,1.14,1.14,0,0,1,.83-.34,1.33,1.33,0,0,1,1,.56,2.64,2.64,0,0,1,.44.91L83.9,208a1.49,1.49,0,0,1,1.61-.36,1.35,1.35,0,0,1,.83,1,1.31,1.31,0,0,1-.1.84A.68.68,0,0,1,86.07,209.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.06,228.59c-.17-.08-7-2.15-6.84,4.82s7.12,5.39,7.12,5.19S70.06,228.59,70.06,228.59Z",
    style: {
      fill: "#db8a76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.16,236s-.12.09-.32.19a1.25,1.25,0,0,1-.91,0,3,3,0,0,1-1.45-2.66,4.11,4.11,0,0,1,.31-1.75,1.39,1.39,0,0,1,.89-.95.62.62,0,0,1,.73.32c.1.19,0,.33.09.34s.15-.12.09-.4a.86.86,0,0,0-.29-.44.93.93,0,0,0-.67-.16,1.71,1.71,0,0,0-1.25,1.11,4.23,4.23,0,0,0-.38,2c.07,1.4.82,2.7,1.83,3a1.3,1.3,0,0,0,1.11-.2C68.15,236.17,68.18,236,68.16,236Z",
    style: {
      fill: "#9a5d53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61,343.58a16.39,16.39,0,0,1-14.47-10.72C75.69,320.74,69.05,302,66.48,291.25c-6.66-27.82,4.56-25.67,9.94-26.4,3.11-.41,11.49,5.94,13.81,11.61,1.88,4.6,11.39,42.7,11.39,42.7L140,331l.15,0-2.6,15Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18,257.25l26.72,4.86c.68.79,11.32,18.3,13.65,23.43s10.27,32.87,10.27,32.87l17.82,17-8.63,13a28.45,28.45,0,0,1-11.32,9.91c-8.16,4-18.65,8.68-22.25,8.68a21,21,0,0,1-6.73-1.38l-.06,0,0,0c-.29-.56-26.27-56-27.88-72.9A58.4,58.4,0,0,1,69.18,257.25Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,281c-2.05,8.89-12.76,46.2-12.76,46.2l-41.64,14.48-.75-3.34,39.48-14.67,12-43.61a1.92,1.92,0,0,1,2.24-1.36h0A1.91,1.91,0,0,1,194.27,281Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,332.8l9.87-7.57L165.34,329s-.23,1.38-2.25,2.05l-4.26-.67,7.85,5.39a4.29,4.29,0,0,1-3,3,7.8,7.8,0,0,0-3.92,2.81l-3,3.12a5.19,5.19,0,0,1-4.05,1.61l-7.81-.46-7.31-.74,2.15-12.34Z",
    style: {
      fill: "#db8a76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,276.46c1.88,4.6,11.39,42.7,11.39,42.7L140,331l.15,0-2.6,15-42.94-2.42a16.39,16.39,0,0,1-14.47-10.72C75.69,320.74,69.05,302,66.48,291.25",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,276.46s.07.27.24.76.38,1.26.68,2.24c.56,2,1.36,4.86,2.34,8.58,2,7.44,4.7,18.15,8,31.16l0,.11.11,0,38.36,11.86h0a.45.45,0,0,1,.16,0l-.18-.27c-.84,4.81-1.71,9.85-2.61,15l.24-.19-3.06-.17-40-2.24a16.22,16.22,0,0,1-8.27-2.88,16,16,0,0,1-5.36-6.31c-.58-1.22-1-2.5-1.46-3.74s-.9-2.45-1.33-3.65q-1.29-3.58-2.46-6.87c-3.1-8.77-5.46-15.91-7-20.89-.76-2.49-1.3-4.43-1.66-5.75-.17-.65-.31-1.15-.4-1.51l-.15-.51a4.93,4.93,0,0,0,.1.52c.09.36.2.87.36,1.52.33,1.33.85,3.28,1.58,5.78,1.45,5,3.77,12.16,6.83,20.95.77,2.19,1.59,4.49,2.43,6.88l1.32,3.66c.46,1.23.87,2.51,1.46,3.77a16.58,16.58,0,0,0,14,9.45l40,2.28,3.07.17h.2l0-.2c.89-5.14,1.76-10.19,2.6-15l0-.22-.22,0-.16,0h0L101.68,319l.13.13c-3.29-13-6.08-23.7-8.11-31.12-1-3.72-1.85-6.61-2.44-8.57-.32-1-.54-1.72-.74-2.21S90.23,276.46,90.23,276.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,275.54a8.77,8.77,0,0,1,2-3.27,12.9,12.9,0,0,1,8.36-3.52,13.19,13.19,0,0,1,5,1,14.37,14.37,0,0,1,3.61,2.09,22.38,22.38,0,0,1,2.72,2.75,3.34,3.34,0,0,0-.55-.9,12.46,12.46,0,0,0-2-2.11,13.72,13.72,0,0,0-8.81-3.26A12.7,12.7,0,0,0,68.93,272a7.07,7.07,0,0,0-1.52,2.46,3.92,3.92,0,0,0-.19.76A1,1,0,0,0,67.19,275.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.05,323.93a226.34,226.34,0,0,0,50.52,13.28c28.48,4,42.92.78,46,9.27,2.28,6.38,4.88,39.55,4.88,39.55s-53.56,4.74-62.95-.52c-16.68-9.37-23.75-24.8-29.42-39.2-6.54-16.63-9-22.38-9-22.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.52,346.48a2.9,2.9,0,0,1,.62,0l1.78.22,6.69.89L186,350.89l.14,0,.05.13c2.1,5.93,4.4,12.44,6.82,19.26,4.86,13.84,9.25,26.37,12.45,35.48,1.56,4.52,2.82,8.19,3.71,10.78l1,2.93.24.77a1.29,1.29,0,0,1,.07.27,1,1,0,0,1-.12-.25c-.07-.2-.17-.45-.29-.75l-1.08-2.91-3.87-10.71c-3.23-9.1-7.68-21.61-12.59-35.43-2.4-6.83-4.7-13.35-6.78-19.28l.19.16-23.32-3.44-6.67-1-1.77-.29Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselSvg2);
export default __webpack_public_path__ + "static/media/carouselSvg2.18dea0e554132fb9ae3272ecfc60f8f3.svg";
export { ForwardRef as ReactComponent };